<script>
import DetectSteps from '../Steps/DetectSteps.vue'

import ScanIcon from '../assets/scan.svg'
import PhoneIcon from '../assets/phone.svg'
import VideoRecorderIcon from '../assets/video-recorder.svg'
import CellPhoneNeedKnown from './CellPhoneNeedKnown.vue'
import ConfigCellPhone from './ConfigCellPhone.vue'
import ConfigPC from './ConfigPC.vue'

export default {
  components: {
    DetectSteps,
    CellPhoneNeedKnown,
    ConfigCellPhone,
    ConfigPC
  },
  inject: ['setDetectInfo'],
  data() {
    return {
      activeStep: 1,
      detectSteps: [
        {
          name: '手机监控须知',
          status: undefined,
          icon: ScanIcon
        },
        {
          name: '配置手机摄像监控',
          status: undefined,
          icon: PhoneIcon
        },
        {
          name: '配置电脑摄像监控',
          status: undefined,
          icon: VideoRecorderIcon
        }
      ]
    }
  },
  methods: {
    hanndNeedKnowClick() {
      this.activeStep++
      this.detectSteps[0].status = 'success'
    },
    handleCellPhonePreviewPass() {
      this.activeStep++
      this.detectSteps[1].status = 'success'
      this.setDetectInfo({
        cellPhone: {
          result: '在线',
          isPass: true
        }
      })
    },
    handleJumpToNextStep() {
      this.activeStep++
      this.detectSteps[1].status = 'fail'
      this.setDetectInfo({
        cellPhone: {
          result: '不在线',
          isPass: false
        }
      })
    },
    handleCellPhoneFail() {
      this.detectSteps[1].status = 'fail'
      this.setDetectInfo({
        cellPhone: {
          result: '不在线',
          isPass: false
        }
      })
    },
    handlePCCameraDetectFinish(result) {
      this.detectSteps[2].status = result ? 'success' : 'fail'
      this.setDetectInfo({
        pc: {
          result: result ? '通过' : '异常',
          isPass: result
        }
      })
    },
    handleGoToPrepareTestStep() {
      this.$emit('config-detect-finish', {
        isCellPhonePass: this.detectSteps[1].status === 'success',
        isPCPass: this.detectSteps[2].status === 'success'
      })
    }
  },
  mounted() {}
}
</script>
<template>
  <div class="detect-box">
    <div class="detect-box-content">
      <DetectSteps :active="activeStep" :steps="detectSteps" />
      <div class="detect-steps-content">
        <CellPhoneNeedKnown v-if="activeStep === 1" />
        <ConfigCellPhone
          @cell-phone-pass="handleCellPhonePreviewPass"
          @cell-phone-fail="handleCellPhoneFail"
          v-if="activeStep === 2"
        />
        <ConfigPC
          @detect-finsh="handlePCCameraDetectFinish"
          v-if="activeStep === 3"
        />
      </div>
    </div>
    <div v-if="activeStep === 1" class="device-detect-btns">
      <button class="btn btn-single" @click="hanndNeedKnowClick">下一步</button>
    </div>
    <div v-if="activeStep === 2" class="device-detect-btns">
      <button @click="handleJumpToNextStep" class="btn btn-single">
        暂时跳过
      </button>
    </div>
    <div v-if="activeStep === 3" class="device-detect-btns">
      <button @click="handleGoToPrepareTestStep" class="btn btn-single">
        {{
          detectSteps[2].status === 'fail'
            ? '暂时跳过'
            : '我已满足监控要求，下一步'
        }}
      </button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.detect-box {
  width: 760px;
  margin: auto;
  margin-top: 50px;
  padding-bottom: 40px;
}
.detect-box-content {
  background-color: #F7FAFF;;
  border-radius: 12px;
  width: 760px;
  min-height: 339px;
  margin: auto;
  margin-top: 15px;
  display: flex;
  padding: 32px 24px 32px 108px;
  margin-bottom: 40px;
}
.detect-steps-content {
  display: flex;
  align-items: center;
  flex: 1;
}
.btn {
  width: 184px;
  height: 48px;
  border-radius: 8px;
  padding: 12px 24px;
  border: none;
  background: linear-gradient(96deg, #329dfc 0%, #397efd 100%);
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
.btn:hover {
  background: linear-gradient(96deg, #329dfc 0%, #397efd 100%);
  opacity: 0.8;
}
.btn:active {
  background: linear-gradient(96deg, #0d8dff 0%, #005aff 100%);
}
.btn-single {
  width: 340px;
}
.btn-disabled {
  background-color: #cbcfdfff;
  background: none;
  color: #ffffff;
  cursor: not-allowed;
  pointer-events: none;
}

.btn-outline {
  width: 184px;
  height: 48px;
  border-radius: 8px;
  padding: 12px 24px;
  border: 1px solid #155eef;
  background-color: transparent;
  color: #155eef;
  font-size: 16px;
  cursor: pointer;
}
.btn-outline:hover {
  border: 1px solid #597ef7ff;
  color: #597ef7ff;
}
.btn-outline:active {
  border: 1px solid #1d39c4ff;
  color: #1d39c4ff;
}
.device-detect-btns {
  display: flex;
  justify-content: center;
}
</style>
